<template>
  <section class="hajj-quick-access d-flex gap-4 flex-wrap">
    <div
      v-for="card in cards"
      :key="card.text"
      :class="{
        'd-none': $store.getters['enums/is_not_permitted'](card.permission),
      }"
    >
      <div
        class="hajj-card-body cursor-pointer"
        v-if="!$store.getters['enums/is_not_permitted'](card.permission)"
        @click="moveTo(card.route)"
      >
        <div class="hajj-card-body__icon-wrap mb-3">
          <span class="hajj-card-body__icon" aria-hidden="true">{{
            card.icon
          }}</span>
        </div>
        <h2 class="hajj-card-body__title">
          <span>{{ $t(card.text) }}</span>
        </h2>
        <div
          class="hajj-card-body__footer d-flex justify-content-between flex-wrap align-items-end"
        >
          <span v-if="card.subText" class="hajj-card-body__sub">{{
            $t(card.subText)
          }}</span>
          <div class="my-1 ms-auto">
            <img
              src="@/assets/images/icons/arrow-right-quick.png"
              :class="{ '-scale-1': isLangRtl }"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HajjModuleQuickAccess",
  computed: {
    isLangRtl() {
      return this.$store.getters["enums/rtlLangs"]?.includes(
        this.$store.getters["enums/lang"],
      );
    },
    cards() {
      return [
        {
          text: "morabata-listing-title",
          subText: "morabata-listing-sub",
          permission: "hajjModule",
          route: "/morabata/listing",
          icon: "☰",
        },
        {
          text: "hajj-attendance-listing-title",
          subText: "hajj-attendance-listing-sub",
          permission: "hajjModule",
          route: "/hajj/attendance/listing",
          icon: "☰",
        },
        {
          text: "hajj-service-company-listing-title",
          subText: "hajj-service-company-listing-sub",
          permission: "hajjModule",
          route: "/hajj/service-companies/listing",
          icon: "☰",
        },
        {
          text: "hajj-dawra-listing-title",
          subText: "hajj-dawra-listing-sub",
          permission: "hajjModule",
          route: "/hajj/dawra/listing",
          icon: "☰",
        },
        {
          text: "hajj-generate-from-operations-title",
          subText: null,
          permission: "generateReservation",
          route: { name: "hajj-sales-order-generate-from-operations" },
          icon: "✎",
        },
        {
          text: "hajj-garage-transfer-title",
          subText: "hajj-garage-transfer-sub",
          permission: "hajjModule",
          route: "/hajj/garage-transfer/add",
          icon: "✎",
        },
        {
          text: "hajj-sales-order-listing-title",
          subText: "hajj-sales-order-listing-sub",
          permission: "generateReservation",
          route: { name: "hajj-sales-order-listing" },
          icon: "☰",
        },
        {
          text: "hajj-csp-listing-title",
          subText: "hajj-csp-listing-sub",
          permission: "hajjModule",
          route: "/hajj/client-season-pricing/listing",
          icon: "☰",
        },
        {
          text: "taseed-resource-lookup-title",
          subText: null,
          permission: "listTaseedOperationOrder",
          route: { name: "taseed-resource-lookup" },
          icon: "✎",
        },
      ];
    },
  },
  methods: {
    moveTo(route) {
      if (route) this.$router.push(route).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.hajj-card-body {
  padding: 20px 20px 18px;
  background: linear-gradient(145deg, var(--color-01) 0%, var(--color-11) 100%);
  border: 1px solid var(--color-15);
  border-radius: 12px;
  width: 390px;
  max-width: 100%;
  margin-block-start: 16px;
  box-shadow: 0px 2px 8px 0px #00000018;
  flex: 0 1 auto;
  min-height: 168px;
  transition:
    box-shadow 0.2s ease,
    transform 0.15s ease;

  &:hover {
    box-shadow: 0px 4px 14px 0px #00000024;
    transform: translateY(-1px);
  }

  &__icon-wrap {
    display: flex;
    align-items: center;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: var(--color-01);
    border: 1px solid var(--color-15);
    font-size: 22px;
    line-height: 1;
  }

  &__title span {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.25;
  }

  &__sub {
    font-size: 14px;
    max-width: 280px;
    color: var(--color-02);
    opacity: 0.92;
  }
}
</style>
